<mat-nav-list>
  <!-- Home link -->
  <app-nav-link [linkData]="mainNavService.homeLink" (closeDrawer)="closeDrawer.emit()" />

  @for (linkCollection of linkCollections(); track linkCollection) {
    <ng-template #title>
      <div class="menu-divider">
        <mat-divider class="divider-leading" />
        <div class="divider-text">{{ linkCollection.title }}</div>
        <mat-divider class="divider-trailing" />
      </div>
    </ng-template>
    <!-- LINKS -->
    @if (linkCollection.links?.length > 0) {
      <div class="link-collection">
        <ng-template [ngTemplateOutlet]="title" />
        @for (navLink of linkCollection.links; track navLink) {
          <app-nav-link [linkData]="navLink" (closeDrawer)="closeDrawer.emit()" />
        }
      </div>
    }
    <!-- EXPANDABLE SECTIONS -->
    @if (linkCollection.sections?.length > 0) {
      <div class="section-collection">
        <ng-template [ngTemplateOutlet]="title" />
        @for (section of linkCollection.sections; track section) {
          <mat-accordion>
            <mat-expansion-panel
              class="mat-elevation-z0"
              [expanded]="expansionPanelStates()[section.title]"
              (opened)="openMenu(); mainNavService.updateExpansionPanelState(section.title, true)"
              (closed)="closeMenu(); mainNavService.updateExpansionPanelState(section.title, false)"
              (click)="$event.stopPropagation(); $event.preventDefault()">
              <mat-expansion-panel-header [expandedHeight]="'48px'">
                <mat-panel-title
                  [class.menu-open]="mainNavService.mainNavOpen()"
                  [class.menu-closed]="!mainNavService.mainNavOpen()">
                  <div class="link-text">
                    @if (section.matIcon && !section.svgIcon) {
                      <mat-icon class="icon">{{ section.matIcon }}</mat-icon>
                    }
                    @if (section.svgIcon) {
                      <mat-icon [svgIcon]="section.svgIcon" class="icon white" />
                    }
                    <span [@animateText]="mainNavService.mainNavOpen() ? 'show' : 'hide'">
                      {{ section.title }}
                    </span>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              @for (sectionLink of section.links; track sectionLink) {
                <app-nav-link [linkData]="sectionLink" [sectionLink]="true" (closeDrawer)="closeDrawer.emit()" />
              }
            </mat-expansion-panel>
          </mat-accordion>
        }
      </div>
    }
  }
</mat-nav-list>
